// extracted by mini-css-extract-plugin
export default {"reportContainer":"Reports_reportContainer__wsBmm"};